import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@envs/environment';
import {
    CatalogoPreguntasSeguridadResponse,
    EstadoPreguntasSeguridadResponse,
    GuardarPreguntasSeguridadRequest,
    GuardarPreguntasSeguridadResponse
} from '@features/authentication/models/preguntas-seguridad.interface';
import { Observable } from 'rxjs';

/**
 * Cliente HTTP de preguntas de seguridad (PLUS-0097-H5).
 * Catalogo, estado y guardar requieren JWT (Bearer).
 */
@Injectable({
    providedIn: 'root'
})
export class PreguntasSeguridadService {

    private readonly _httpClient = inject(HttpClient);
    private static readonly BASE_URL = environment.API_URL
        .concat(environment.CW_AUTH)
        .concat('/apimediador/siafpplus/servicioGestionUsuarios');

    private static readonly CATALOGO_URL = `${PreguntasSeguridadService.BASE_URL}/consultarCatalogoPreguntasSeguridad/v1`;
    private static readonly ESTADO_URL = `${PreguntasSeguridadService.BASE_URL}/consultarEstadoPreguntasSeguridad/v1`;
    private static readonly GUARDAR_URL = `${PreguntasSeguridadService.BASE_URL}/guardarPreguntasSeguridad/v1`;

    /**
     * Consulta el catalogo de preguntas activas (con Bearer).
     */
    public consultarCatalogo(): Observable<CatalogoPreguntasSeguridadResponse> {
        return this._httpClient.get<CatalogoPreguntasSeguridadResponse>(
            PreguntasSeguridadService.CATALOGO_URL
        );
    }

    /**
     * Consulta si el usuario de la sesion ya tiene las preguntas registradas.
     */
    public consultarEstado(): Observable<EstadoPreguntasSeguridadResponse> {
        return this._httpClient.get<EstadoPreguntasSeguridadResponse>(
            PreguntasSeguridadService.ESTADO_URL
        );
    }

    /**
     * Persiste las preguntas del usuario autenticado.
     *
     * @param request respuestas en claro
     */
    public guardar(request: GuardarPreguntasSeguridadRequest): Observable<GuardarPreguntasSeguridadResponse> {
        return this._httpClient.post<GuardarPreguntasSeguridadResponse>(
            PreguntasSeguridadService.GUARDAR_URL,
            request
        );
    }
}
